import React from 'react';
import ReactDOM from 'react-dom';
import './core/i18n/i18n'

import './index.css';
import PatientApp from "./PatientApp";
import HisApp from "./HisApp";
import { LocalStorageService } from "./core/service/LocalStorageService";
import PatientLocalStorage from "./patient-app/PatientLocalStorage";
import ApiService from "./core/service/ApiService";
import {startVersionWatch} from "./core/service/VersionWatcher";
import { loadBranding } from "./core/service/BrandingService";
import { applyAntdThemeToStaticApis } from "./core/styles/antd-theme";

// Modal.confirm / message / notification React ağacının dışında render edilir; temayı
// oradan da bağlamazsak onay modallarındaki butonlar antd'nin fabrika mavisinde kalır.
applyAntdThemeToStaticApis();

const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';

window.addEventListener('error', (e) => {
    if (e.message && e.message.includes(resizeObserverLoopErr)) {
        e.stopImmediatePropagation();
    }
});

/**
 * Marka (başlık, açıklama, favicon, logolar) artık configuration.json'da DEĞİL, DB'de.
 * configuration.json yalnız altyapı taşır (API adresleri) — o ortama özeldir, DB'den okunamaz.
 * Marka yüklemesi uygulamayı bloklamaz: API yoksa cache'e, o da yoksa gömülü varsayılana düşer.
 */
const init = async (module) => {
    // <html lang> seçili dile bağlanır. Sabit "en" iken iki sorun vardı:
    //   1) Chrome, Türkçe içerikli sayfayı İngilizce sanıp "çevireyim mi?" diye soruyordu.
    //   2) CSS text-transform: uppercase dönüşümü dile göre yapılır; en'de "istanbul" → "ISTANBUL"
    //      (doğrusu "İSTANBUL"). Noktalı İ kayboluyordu.
    document.documentElement.lang = LocalStorageService.getLanguage('tr')

    await loadBranding(module)
}

const loadPatient = async () => {
    const res = await fetch('/configuration.json')
    const config = await res.json()
    window.AppSettings = {
        ...config
    }

    await init('online')

    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token');
    if (accessToken) {
        PatientLocalStorage.saveToken(accessToken)
        const res = await ApiService.PatientApp.GetPatient()
        if (res.success) {
            PatientLocalStorage.saveInformation(res.data)
        }
    }

    ReactDOM.render(
        <PatientApp />,
        document.getElementById('root')
    );

    startVersionWatch();
}

const loadHIS = async () => {
    const res = await fetch('/configuration.json')
    const config = await res.json()
    window.AppSettings = {
        ...config
    }

    await init('his')

    ReactDOM.render(
        <HisApp />,
        document.getElementById('root')
    );

    startVersionWatch();
}

//loadPatient()
loadHIS()
